// extracted by mini-css-extract-plugin
export var actionText = "_m0-4";
export var container = "_m0-0";
export var leftSection = "_m0-1";
export var rightSection = "_m0-2";
export var settingsButton = "_m0-6";
export var settingsIcon = "_m0-7";
export var shortcut = "_m0-5";
export var shortcutGroup = "_m0-3";